var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-template',{attrs:{"header":_vm.header,"is-loading":_vm.isLoading}},[_c('property-list',{attrs:{"property-list":_vm.propertyList,"list-type":_vm.listType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }